/* Crew storefront tracking pixel.
   Two transports, chosen by whichever config the served snippet bakes in:

   1. Supabase collector (Option B, preferred — Crew stays private):
        window.CREW_KEY, window.CREW_SB_URL, window.CREW_SB_ANON, window.CREW_SB_TABLE
      Posts events straight into a Supabase table with an insert-only RLS policy.
      Uses fetch(keepalive) because the apikey header sendBeacon can't set.

   2. Direct-to-Crew (legacy — needs a public Crew URL):
        window.CREW_KEY, window.CREW_ENDPOINT
      Posts text/plain JSON via sendBeacon to Crew's /api/track (no CORS preflight).

   Each event carries enrichment: campaign (UTM), device, viewport, language,
   timezone, coarse geo (city/region/country via a cached IP lookup), the
   session landing page, and — when available — the logged-in Shopify customer
   id, currency, and product id. Captures page views, product views,
   add-to-cart, and checkout starts (incl. the add-to-carts the Admin API hides). */
(function () {
  var KEY = window.CREW_KEY;
  if (!KEY) return;

  var SB_URL = window.CREW_SB_URL, SB_ANON = window.CREW_SB_ANON,
      SB_TABLE = window.CREW_SB_TABLE || 'journey_events';
  var ENDPOINT = window.CREW_ENDPOINT;
  var useSupabase = !!(SB_URL && SB_ANON);
  if (!useSupabase && !ENDPOINT) return;

  function cookie(name, value, days) {
    if (value === undefined) {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? m.pop() : '';
    }
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); }
    catch (e) { return null; }
  }

  var vid = cookie('_crew_vid'); if (!vid) { vid = uid(); cookie('_crew_vid', vid, 365); }
  var sid = ss('_crew_sid'); if (!sid) { sid = uid(); ss('_crew_sid', sid); }

  // ── Device ───────────────────────────────────────────────────────
  function deviceType() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet|PlayBook|Silk|(Android(?!.*Mobile))/i.test(ua)) return 'tablet';
    if (/Mobi|Android|iPhone|iPod|IEMobile|BlackBerry|Opera Mini/i.test(ua)) return 'mobile';
    return 'desktop';
  }

  // ── UTM + landing page: capture once, persist for the whole session ─
  function readUtm() {
    var o = {};
    try {
      var p = new URLSearchParams(location.search);
      ['source', 'medium', 'campaign'].forEach(function (k) {
        var v = p.get('utm_' + k); if (v) o['utm_' + k] = v.slice(0, 200);
      });
    } catch (e) {}
    return o;
  }
  var LAND = ss('_crew_land');
  if (!LAND) { LAND = (location.pathname + location.search).slice(0, 1000); ss('_crew_land', LAND); }
  var UTM = ss('_crew_utm');
  if (UTM === null) { UTM = JSON.stringify(readUtm()); ss('_crew_utm', UTM); }
  try { UTM = JSON.parse(UTM); } catch (e) { UTM = {}; }

  // ── Shopify context: logged-in customer, currency, product ─────────
  function shopCtx() {
    var o = {};
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (m) {
        if (m.page && m.page.customerId) o.shop_customer_id = String(m.page.customerId);
        if (m.currency) o.currency = m.currency;
        if (m.product && m.product.id) {
          o.product_id = String(m.product.id);
          try {
            var v = m.product.variants && m.product.variants[0];
            if (v && v.price) o.value = (+v.price) / 100;  // Shopify prices are in cents
          } catch (e) {}
        }
      }
      if (!o.currency && window.Shopify && Shopify.currency) o.currency = Shopify.currency.active;
    } catch (e) {}
    return o;
  }

  // ── Coarse geo via a keyless HTTPS IP lookup, cached per session ────
  var GEO = {};
  (function () { try { var c = ss('_crew_geo'); if (c) GEO = JSON.parse(c); } catch (e) {} })();
  function withGeo(cb) {
    if (GEO && GEO._loaded) return cb();
    var done = false;
    var t = setTimeout(function () { if (!done) { done = true; cb(); } }, 1500);
    try {
      fetch('https://ipwho.is/', { referrerPolicy: 'no-referrer' })
        .then(function (r) { return r.json(); })
        .then(function (g) {
          if (done) return; done = true; clearTimeout(t);
          if (g && g.success !== false) {
            GEO = { _loaded: 1, country: g.country_code || '', region: g.region || '', city: g.city || '' };
          } else { GEO = { _loaded: 1 }; }
          ss('_crew_geo', JSON.stringify(GEO));
          cb();
        })
        .catch(function () { if (!done) { done = true; clearTimeout(t); cb(); } });
    } catch (e) { if (!done) { done = true; clearTimeout(t); cb(); } }
  }

  var STATIC = {
    device: deviceType(),
    viewport: (screen.width || 0) + 'x' + (screen.height || 0),
    language: navigator.language || '',
    timezone: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; } })(),
    landing_page: LAND
  };

  function send(event, extra) {
    var base = {
      visitor_id: vid, session_id: sid, event: event,
      url: (location.pathname + location.search).slice(0, 1000),
      title: (document.title || '').slice(0, 255),
      referrer: document.referrer || ''
    };
    function put(src) { if (src) for (var k in src) if (k.charAt(0) !== '_') base[k] = src[k]; }
    put(STATIC); put(UTM); put(GEO); put(shopCtx()); put(extra);
    try {
      if (useSupabase) {
        base.pixel_key = KEY;  // maps the row back to a Crew brand
        fetch(SB_URL + '/rest/v1/' + SB_TABLE, {
          method: 'POST', keepalive: true,
          headers: {
            'apikey': SB_ANON, 'Authorization': 'Bearer ' + SB_ANON,
            'Content-Type': 'application/json', 'Prefer': 'return=minimal'
          },
          body: JSON.stringify(base)
        }).catch(function () { /* never break the store */ });
      } else {
        base.key = KEY;
        navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify(base)], { type: 'text/plain' }));
      }
    } catch (e) { /* never break the store */ }
  }

  // Entry event, fired once geo resolves (or times out) so it carries location.
  withGeo(function () {
    var path = location.pathname;
    if (path.indexOf('/products/') > -1) send('product_viewed', { product: document.title });
    else if (path.indexOf('/checkout') > -1 || path.indexOf('/checkouts') > -1) send('checkout_started');
    else send('page_viewed');
  });

  // Add-to-cart: intercept both the AJAX (/cart/add.js) and form-submit paths.
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      try {
        var u = arguments[0] && (arguments[0].url || arguments[0]);
        if (typeof u === 'string' && u.indexOf('/cart/add') > -1) send('add_to_cart', { product: document.title });
      } catch (e) {}
      return _fetch.apply(this, arguments);
    };
  }
  document.addEventListener('submit', function (e) {
    try {
      var a = (e.target && e.target.getAttribute('action')) || '';
      if (a.indexOf('/cart/add') > -1) send('add_to_cart', { product: document.title });
    } catch (err) {}
  }, true);
  // Enquiry intent: WhatsApp / email / phone links. Corporate leads land on WhatsApp,
  // which Crew cannot see; the click is the only signal. `product` carries the channel.
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var h = a.getAttribute('href') || '';
      var ch = /wa\.me|whatsapp/i.test(h) ? 'whatsapp' : /^mailto:/i.test(h) ? 'email' : /^tel:/i.test(h) ? 'phone' : '';
      if (ch) send('enquiry_click', { product: ch });
    } catch (err) {}
  }, true);
})();
